import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base/base/base-component.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-is-invalid',
    template: `
        <div class="d-flex flex-row gap-1">
            <button class="d-flex gap-2 align-items-center btn action-button" (click)="onInvalidItem()">
                <img class="icon" [src]="iconSrc" />
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `,
    ],
    standalone: false,
})
export class IsInvalidComponent extends BaseComponent {
    @Input()
    data: any = {};

    @Output() emitter: Subject<{
        id: number;
        name: string;
        isInvalid: boolean;
    }> = new Subject<{ id: number; name: string; isInvalid: boolean }>();

    public iconSrc: string;

    public ngOnInit() {
        this.getIsInvalid();
    }

    onInvalidItem() {
        this.data.isInvalid = !this.data.isInvalid;
        let id = this.data.promotionCodeId;
        this.emitter.next({
            id: id,
            name: this.data.name,
            isInvalid: this.data.isInvalid,
        });
    }

    getIsInvalid() {
        if (this.data.isInvalid) {
            this.iconSrc = '@imagesDir/restore.png';
        } else {
            this.iconSrc = '@imagesDir/trash.png';
        }
    }
}
